var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-details-section"},[(_vm.infoText)?_c('Help_Section',{staticClass:"w-100",attrs:{"info-text":_vm.infoText}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }